<template>
  <div id="centerBottom">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span class="fs-xl text mx-2">实时监控</span>
      </div>
      <div class="d-flex ai-center flex-column body-box">
        <CenterBottomChart />
      </div>
    </div>
  </div>
</template>

<script>
import CenterBottomChart from './components/centerBottomChart'
export default {
  components: {
    CenterBottomChart
  }
};
</script>

<style lang="scss" scoped>
#centerBottom {
  $box-height: 320px;
  $box-width: 800px;
  padding: 5px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;
  .bg-color-black {
    padding: 5px;
    height: $box-height;
    width: $box-width;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    border-radius: 10px;
    overflow: hidden;
    .dv-cap-chart {
      width: 100%;
      height: 160px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/screen/CenterBottom.vue